export const headerImage = {
  medium: {
    width: 704,
    url: 'https://assets.riparide.com/landing_pages/contact_us/header/medium-2022-04-19.jpg',
  },
  large: {
    width: 1057,
    url: 'https://assets.riparide.com/landing_pages/contact_us/header/large-2022-04-19.jpg',
  },
  hero: {
    width: 1408,
    url: 'https://assets.riparide.com/landing_pages/contact_us/header/hero-2022-04-19.jpg',
  },
}

export const headerText = {
  label: 'Contact us',
  title: 'We love hearing from you',
  subtitle: "If you have any questions or feedback, we're here to help.",
}
